(function () {
  "use strict";

  /* ---------------------------------------------------------------
     CONFIG — everything you might want to change lives here.
     --------------------------------------------------------------- */

  var AFF = {
    send: "https://wise.prf.hn/click/camref:1101l4aYDA/destination:https%3A%2F%2Fwise.com%2Fnz%2Fsend-money%2F",
    card: "https://wise.prf.hn/click/camref:1101l4aYDA/destination:https%3A%2F%2Fwise.com%2Fnz%2Fcard%2F"
  };

  /* Cost model.
     pct = share of the send amount lost to fee + FX margin combined.
     fixed = flat fee in NZD.
     Calibrated so a NZ$5,000 NZD->USD transfer reproduces published
     third-party comparison figures (Wise 16.37, XE 30.18, OFX 39.02,
     CurrencyFair 41.56, TorFX 50.51, Currencies Direct 60.73, BNZ 77.46,
     ASB 84.58, Kiwibank 108.39, PayPal 226.85).
     ANZ and Westpac are interpolated between BNZ and Kiwibank.
     Wise's real fee varies roughly 0.25%-1.1% by currency, so treat the
     Wise figure as the low end of a range, not a quote. */
  var PROVIDERS = [
    { name: "Wise",              pct: 0.0031, fixed: 0.85, kind: "best",   speed: "Seconds – 1 day",  wise: true },
    { name: "XE",                pct: 0.0060, fixed: 0,    kind: "fx",     speed: "1 – 3 days" },
    { name: "OFX",               pct: 0.0078, fixed: 0,    kind: "fx",     speed: "1 – 3 days" },
    { name: "CurrencyFair",      pct: 0.0083, fixed: 0,    kind: "fx",     speed: "1 – 3 days" },
    { name: "TorFX",             pct: 0.0101, fixed: 0,    kind: "fx",     speed: "1 – 3 days" },
    { name: "Currencies Direct", pct: 0.0121, fixed: 0,    kind: "fx",     speed: "1 – 3 days" },
    { name: "BNZ",               pct: 0.0125, fixed: 15,   kind: "bank",   speed: "1 – 5 days" },
    { name: "ASB",               pct: 0.0133, fixed: 18,   kind: "bank",   speed: "1 – 5 days" },
    { name: "ANZ",               pct: 0.0140, fixed: 18,   kind: "bank",   speed: "1 – 5 days" },
    { name: "Westpac",           pct: 0.0145, fixed: 15,   kind: "bank",   speed: "1 – 5 days" },
    { name: "Kiwibank",          pct: 0.0167, fixed: 25,   kind: "bank",   speed: "1 – 5 days" },
    { name: "PayPal",            pct: 0.0454, fixed: 0,    kind: "wallet", speed: "Minutes" }
  ];

  var CCY = [
    ["NZD","New Zealand Dollar"],["AUD","Australian Dollar"],["USD","US Dollar"],
    ["GBP","British Pound"],["EUR","Euro"],["INR","Indian Rupee"],
    ["PHP","Philippine Peso"],["JPY","Japanese Yen"],["THB","Thai Baht"],
    ["CNY","Chinese Yuan"],["FJD","Fijian Dollar"],["ZAR","South African Rand"],
    ["CAD","Canadian Dollar"],["SGD","Singapore Dollar"],["HKD","Hong Kong Dollar"],
    ["KRW","South Korean Won"],["VND","Vietnamese Dong"],["IDR","Indonesian Rupiah"],
    ["MYR","Malaysian Ringgit"],["LKR","Sri Lankan Rupee"],["NPR","Nepalese Rupee"],
    ["PKR","Pakistani Rupee"],["BDT","Bangladeshi Taka"],["AED","UAE Dirham"],
    ["CHF","Swiss Franc"],["SEK","Swedish Krona"],["NOK","Norwegian Krone"],
    ["DKK","Danish Krone"],["PLN","Polish Zloty"],["CZK","Czech Koruna"],
    ["HUF","Hungarian Forint"],["TRY","Turkish Lira"],["MXN","Mexican Peso"],
    ["BRL","Brazilian Real"],["ILS","Israeli Shekel"],["TWD","Taiwan Dollar"],
    ["SAR","Saudi Riyal"],["RON","Romanian Leu"],["ARS","Argentine Peso"],
    ["CLP","Chilean Peso"],["COP","Colombian Peso"],["EGP","Egyptian Pound"],
    ["KES","Kenyan Shilling"],["NGN","Nigerian Naira"],["MUR","Mauritian Rupee"],
    ["XPF","CFP Franc"],["WST","Samoan Tala"],["TOP","Tongan Paʻanga"],
    ["VUV","Vanuatu Vatu"],["PGK","Papua New Guinean Kina"]
  ];

  /* Countries Wise cannot send to from New Zealand. Never pitch a transfer
     for these — show the honest note instead. */
  var WISE_UNSUPPORTED = { WST: "Samoa", TOP: "Tonga", VUV: "Vanuatu", PGK: "Papua New Guinea", XPF: "the French Pacific territories" };

  /* Indicative fallback rates per 1 NZD. Only used if every live source
     fails, and the widget says so plainly when that happens. */
  var FALLBACK = {
    NZD:1, AUD:0.915, USD:0.598, GBP:0.468, EUR:0.549, INR:52.4, PHP:34.2,
    JPY:88.6, THB:19.4, CNY:4.28, FJD:1.345, ZAR:10.85, CAD:0.822, SGD:0.774,
    HKD:4.67, KRW:820, VND:15600, IDR:9750, MYR:2.55, LKR:180, NPR:83.8,
    PKR:167, BDT:72.5, AED:2.196, CHF:0.481, SEK:5.72, NOK:6.28, DKK:4.10,
    PLN:2.34, CZK:12.7, HUF:212, TRY:24.4, MXN:11.1, BRL:3.28, ILS:2.15,
    TWD:18.9, SAR:2.243, RON:2.73, ARS:790, CLP:565, COP:2380, EGP:29.1,
    KES:77.2, NGN:905, MUR:27.6, XPF:65.5, WST:1.63, TOP:1.42, VUV:72.5, PGK:2.44
  };

  var SOURCES = [
    { url: function (b) { return "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/" + b.toLowerCase() + ".json"; },
      parse: function (j, b) { var r = j[b.toLowerCase()]; if (!r) return null; var o = {}; for (var k in r) o[k.toUpperCase()] = r[k]; return { rates: o, date: j.date }; } },
    { url: function (b) { return "https://latest.currency-api.pages.dev/v1/currencies/" + b.toLowerCase() + ".json"; },
      parse: function (j, b) { var r = j[b.toLowerCase()]; if (!r) return null; var o = {}; for (var k in r) o[k.toUpperCase()] = r[k]; return { rates: o, date: j.date }; } },
    { url: function (b) { return "https://open.er-api.com/v6/latest/" + b.toUpperCase(); },
      parse: function (j) { if (!j.rates) return null; return { rates: j.rates, date: j.time_last_update_utc }; } },
    { url: function (b) { return "https://api.frankfurter.dev/v1/latest?base=" + b.toUpperCase(); },
      parse: function (j) { if (!j.rates) return null; var o = {}; for (var k in j.rates) o[k] = j.rates[k]; o[j.base] = 1; return { rates: o, date: j.date }; } }
  ];

  /* ---------------------------------------------------------------
     Rate loading — try each source in turn, cache in sessionStorage
     --------------------------------------------------------------- */

  var CACHE_KEY = "cxw_rates_nzd_v1";
  var CACHE_TTL = 3 * 60 * 60 * 1000; /* 3 hours */
  var ratesPromise = null;

  function readCache() {
    try {
      var raw = window.sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || (Date.now() - o.t) > CACHE_TTL) return null;
      return o.d;
    } catch (e) { return null; }
  }
  function writeCache(d) {
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }

  function fetchJSON(url) {
    if (!window.fetch) return Promise.reject(new Error("no fetch"));
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 6000) : null;
    return fetch(url, ctl ? { signal: ctl.signal } : {})
      .then(function (r) { if (timer) clearTimeout(timer); if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .catch(function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  function loadRates() {
    if (ratesPromise) return ratesPromise;
    var cached = readCache();
    if (cached) { ratesPromise = Promise.resolve(cached); return ratesPromise; }

    var i = 0;
    function next() {
      if (i >= SOURCES.length) {
        return Promise.resolve({ rates: FALLBACK, date: null, live: false });
      }
      var s = SOURCES[i++];
      return fetchJSON(s.url("NZD"))
        .then(function (j) {
          var p = s.parse(j, "NZD");
          if (!p || !p.rates || !p.rates.AUD) throw new Error("bad shape");
          p.rates.NZD = 1;
          var out = { rates: p.rates, date: p.date, live: true };
          writeCache(out);
          return out;
        })
        .catch(function () { return next(); });
    }
    ratesPromise = next();
    return ratesPromise;
  }

  /* ---------------------------------------------------------------
     Formatting
     --------------------------------------------------------------- */

  var ZERO_DP = { JPY: 1, KRW: 1, VND: 1, IDR: 1, CLP: 1, COP: 1, ARS: 1, HUF: 1, PYG: 1, XPF: 1, VUV: 1 };

  function fmtMoney(n, code) {
    var dp = ZERO_DP[code] ? 0 : 2;
    try {
      return new Intl.NumberFormat("en-NZ", { minimumFractionDigits: dp, maximumFractionDigits: dp }).format(n);
    } catch (e) {
      return n.toFixed(dp);
    }
  }
  /* Drop the ".00" on whole amounts — reads far better inside prose. */
  function fmtNZ(n) { return "NZ$" + fmtMoney(n, "NZD").replace(/\.00$/, ""); }
  function fmtRate(n) {
    var dp = n >= 1000 ? 2 : n >= 100 ? 3 : n >= 1 ? 4 : 5;
    return n.toFixed(dp).replace(/0+$/, "").replace(/\.$/, "");
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }

  function cross(rates, from, to) {
    if (!rates[from] || !rates[to]) return null;
    return rates[to] / rates[from];
  }

  /* ---------------------------------------------------------------
     Markup
     --------------------------------------------------------------- */

  var uid = 0;

  function ccyOptions(sel) {
    return CCY.map(function (c) {
      return '<option value="' + c[0] + '"' + (c[0] === sel ? " selected" : "") + ">" + c[0] + " – " + esc(c[1]) + "</option>";
    }).join("");
  }

  function build(host) {
    var id = "cxw" + (++uid);
    host.innerHTML =
      '<div class="cxw" id="' + id + '">' +
        '<div class="cxw-tabs" role="tablist" aria-label="Currency tools">' +
          '<button class="cxw-tab" role="tab" aria-selected="true"  data-panel="conv">Convert currency</button>' +
          '<button class="cxw-tab" role="tab" aria-selected="false" data-panel="cost">Compare transfer cost</button>' +
        '</div>' +
        '<div class="cxw-body">' +
          '<div class="cxw-controls">' +
            '<div class="cxw-field cxw-field-amount">' +
              '<label for="' + id + '-amt">Amount</label>' +
              '<input id="' + id + '-amt" type="text" inputmode="decimal" value="1,000" autocomplete="off">' +
            '</div>' +
            '<div class="cxw-field">' +
              '<label for="' + id + '-from">From</label>' +
              '<select id="' + id + '-from">' + ccyOptions("NZD") + '</select>' +
            '</div>' +
            '<div class="cxw-field">' +
              '<label for="' + id + '-to">To</label>' +
              '<select id="' + id + '-to">' + ccyOptions("AUD") + '</select>' +
            '</div>' +
          '</div>' +
          '<button class="cxw-swap" type="button">⇅ Swap currencies</button>' +
          '<p class="cxw-status" hidden></p>' +

          '<div class="cxw-panel" data-panel="conv">' +
            '<div class="cxw-result" aria-live="polite">' +
              '<div class="cxw-out">—</div>' +
              '<div class="cxw-rate"></div>' +
              '<div class="cxw-stamp"></div>' +
            '</div>' +
            '<div class="cxw-headline cxw-conv-note"></div>' +
            '<div class="cxw-cta"></div>' +
          '</div>' +

          '<div class="cxw-panel cxw-hide" data-panel="cost">' +
            '<div class="cxw-bars" aria-live="polite"></div>' +
            '<div class="cxw-headline cxw-cost-note"></div>' +
            '<div class="cxw-cta"></div>' +
          '</div>' +
        '</div>' +
        '<div class="cxw-foot">' +
          '<details>' +
            '<summary>How these figures are worked out</summary>' +
            '<ul>' +
              '<li>Exchange rates are the <strong>mid-market rate</strong> — the rate you see on Google or Reuters, with no margin added. Live rates are refreshed from public rate feeds; they are indicative and are not a quote.</li>' +
              '<li>Transfer costs are <strong>modelled estimates</strong>, not live provider quotes. Each provider\'s figure combines its transfer fee with its typical exchange-rate margin, expressed as a single total cost.</li>' +
              '<li>The model is calibrated to reproduce published third-party comparison data for a NZ$5,000 New Zealand → United States transfer. ANZ and Westpac are interpolated from the surrounding banks.</li>' +
              '<li>Real costs vary by currency, amount, payment method and the day you transfer. Wise\'s own fee ranges from about 0.25% to over 1% depending on the currency, so treat the Wise figure as the low end of a range.</li>' +
              '<li><strong>Always confirm the actual quote on the provider\'s own site before you send.</strong></li>' +
            '</ul>' +
          '</details>' +
        '</div>' +
      '</div>';
    return document.getElementById(id);
  }

  /* ---------------------------------------------------------------
     Behaviour
     --------------------------------------------------------------- */

  function init(host) {
    var root = build(host);
    var amtEl  = root.querySelector('input[type="text"]');
    var fromEl = root.querySelector('select[id$="-from"]');
    var toEl   = root.querySelector('select[id$="-to"]');
    var swapEl = root.querySelector(".cxw-swap");
    var statusEl = root.querySelector(".cxw-status");
    var tabs   = Array.prototype.slice.call(root.querySelectorAll(".cxw-tab"));
    var panels = Array.prototype.slice.call(root.querySelectorAll(".cxw-panel"));
    var outEl  = root.querySelector(".cxw-out");
    var rateEl = root.querySelector(".cxw-rate");
    var stampEl= root.querySelector(".cxw-stamp");
    var convNote = root.querySelector(".cxw-conv-note");
    var costNote = root.querySelector(".cxw-cost-note");
    var barsEl = root.querySelector(".cxw-bars");
    var ctaEls = Array.prototype.slice.call(root.querySelectorAll(".cxw-cta"));
    var DATA = null;
    var active = "conv";

    function amount() {
      var v = parseFloat(String(amtEl.value).replace(/[^0-9.]/g, ""));
      return isFinite(v) && v > 0 ? v : 0;
    }

    function setTab(name) {
      active = name;
      tabs.forEach(function (t) { t.setAttribute("aria-selected", t.getAttribute("data-panel") === name ? "true" : "false"); });
      panels.forEach(function (p) { p.classList.toggle("cxw-hide", p.getAttribute("data-panel") !== name); });
      render();
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () { setTab(t.getAttribute("data-panel")); });
    });

    swapEl.addEventListener("click", function () {
      var a = fromEl.value; fromEl.value = toEl.value; toEl.value = a; render();
    });

    [amtEl, fromEl, toEl].forEach(function (el) {
      el.addEventListener("input", render);
      el.addEventListener("change", render);
    });

    amtEl.addEventListener("blur", function () {
      var v = amount();
      if (v) amtEl.value = fmtMoney(v, "NZD").replace(/\.00$/, "");
    });

    function ctaHTML(kind, to, amt) {
      var blocked = WISE_UNSUPPORTED[to];
      if (blocked) {
        return '<p style="font-size:.9rem;margin:0;color:#8a5a00">' +
          '<strong>Wise does not send money to ' + esc(blocked) + '.</strong> For this destination compare Western Union, ' +
          'MoneyGram, Remitly or OrbitRemit instead — and see our ' +
          '<a href="/pages/send-money-overseas-from-nz">guide to sending money overseas from New Zealand</a>.</p>';
      }
      if (kind === "cost") {
        return '<a href="' + AFF.send + '" rel="sponsored nofollow" target="_blank">Check your live Wise quote for ' + fmtNZ(amt) + '</a>';
      }
      return '<a href="' + AFF.card + '" rel="sponsored nofollow" target="_blank">Get the real rate with Wise</a>';
    }

    function renderConverter() {
      var from = fromEl.value, to = toEl.value, amt = amount();
      var r = cross(DATA.rates, from, to);
      if (!r || !amt) {
        outEl.textContent = "—"; rateEl.textContent = ""; convNote.innerHTML = "";
        return;
      }
      var got = amt * r;
      outEl.innerHTML = fmtMoney(got, to) + ' <small>' + to + '</small>';
      rateEl.textContent = "1 " + from + " = " + fmtRate(r) + " " + to + "  ·  1 " + to + " = " + fmtRate(1 / r) + " " + from;

      /* The persuasion: mid-market vs a typical bank rate, in money. */
      var bankPct = 0.014, bankFixed = 18;
      var bankGot = (amt - bankFixed) * r * (1 - bankPct);
      var wiseGot = (amt - 0.85) * r * (1 - 0.0031);
      var diff = wiseGot - bankGot;
      if (diff > 0.01) {
        convNote.innerHTML = 'That is the <strong>mid-market rate</strong> — the real one, with nothing added. ' +
          'Send ' + fmtNZ(amt) + ' through a typical New Zealand bank and the recipient gets roughly <strong>' +
          fmtMoney(bankGot, to) + ' ' + to + '</strong> once the bank\'s fee and exchange-rate margin come out. ' +
          'At the mid-market rate with a low, visible fee, they get about <strong>' + fmtMoney(wiseGot, to) + ' ' + to +
          '</strong> — a difference of roughly <strong>' + fmtMoney(diff, to) + ' ' + to + '</strong>.';
      } else { convNote.innerHTML = ""; }
    }

    function renderCost() {
      var to = toEl.value, amt = amount();
      var from = fromEl.value;
      var r = cross(DATA.rates, from, to);
      if (!r || !amt) { barsEl.innerHTML = ""; costNote.innerHTML = ""; return; }

      var rows = PROVIDERS.map(function (p) {
        var cost = amt * p.pct + p.fixed;
        return { name: p.name, kind: p.kind, speed: p.speed, cost: cost, got: (amt - cost) * r };
      }).sort(function (a, b) { return a.cost - b.cost; });

      var max = rows[rows.length - 1].cost;
      barsEl.innerHTML = rows.map(function (row) {
        var w = Math.max(1, (row.cost / max) * 100);
        return '<div class="cxw-bar-row" data-kind="' + row.kind + '">' +
          '<div class="cxw-bar-name">' + esc(row.name) + '</div>' +
          '<div class="cxw-bar-track"><div class="cxw-bar-fill" style="width:' + w.toFixed(1) + '%"></div></div>' +
          '<div class="cxw-bar-cost">' + fmtNZ(row.cost) + '</div>' +
          '<span class="cxw-sr">' + esc(row.name) + ' costs ' + fmtNZ(row.cost) + '; recipient gets ' + fmtMoney(row.got, to) + ' ' + to + '; arrives in ' + esc(row.speed) + '</span>' +
        '</div>';
      }).join("");

      var best = rows[0], worst = rows[rows.length - 1];
      var banks = rows.filter(function (x) { return x.kind === "bank"; });
      var bankAvg = banks.length ? banks.reduce(function (s, x) { return s + x.cost; }, 0) / banks.length : null;

      var html = 'On ' + fmtNZ(amt) + ' to ' + to + ', the cheapest option here costs about <strong>' + fmtNZ(best.cost) +
        '</strong> and the most expensive about <strong>' + fmtNZ(worst.cost) + '</strong> — a spread of <strong>' +
        fmtNZ(worst.cost - best.cost) + '</strong> on the same transfer.';
      if (bankAvg) {
        html += ' The five big New Zealand banks average <strong>' + fmtNZ(bankAvg) + '</strong>, roughly <strong>' +
          (bankAvg / best.cost).toFixed(1) + '×</strong> the cheapest option.';
      }
      costNote.innerHTML = html;
    }

    function render() {
      if (!DATA) return;
      if (active === "conv") renderConverter(); else renderCost();
      var html = ctaHTML(active, toEl.value, amount());
      ctaEls.forEach(function (el) { el.innerHTML = html; });
    }

    loadRates().then(function (d) {
      DATA = d;
      if (d.live) {
        statusEl.hidden = true;
        stampEl.textContent = "Mid-market rate" + (d.date ? " · updated " + esc(String(d.date)) : "") + " · indicative, not a quote";
      } else {
        statusEl.hidden = false;
        statusEl.textContent = "Live rates are unavailable right now, so these figures are indicative only. Check the provider for a current quote.";
        stampEl.textContent = "Indicative rate — live feed unavailable";
      }
      render();
    });
  }

  function boot() {
    var hosts = document.querySelectorAll('[data-cx-widget="comparison"]');
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].getAttribute("data-cxw-ready")) {
        hosts[i].setAttribute("data-cxw-ready", "1");
        init(hosts[i]);
      }
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();